export const ROLES = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  DISPATCH: 'dispatch',
};

export const ROLE_LABELS = {
  [ROLES.ADMIN]: 'Admin',
  [ROLES.MANAGER]: 'Manager',
  [ROLES.DISPATCH]: 'Dispatch Team',
};

export const MODULES = [
  'dashboard',
  'drivers',
  'driverSchedule',
  'staffSchedule',
  'garage',
  'inspection',
  'tasks',
  'chatSupport',
  'driverDetails',
  'createUser',
];

export const MODULE_LABELS = {
  dashboard: 'Dashboard',
  drivers: 'Drivers',
  driverSchedule: 'Driver Schedule',
  staffSchedule: 'Staff Schedule',
  mySchedule: 'My Schedule',
  garage: 'Fleet',
  inspection: 'Inspection',
  tasks: 'Tasks',
  chatSupport: 'Chat Support',
  driverDetails: 'Driver Details',
  createUser: 'User Management',
};

export const sidebarItems = [
  { name: 'Dashboard', key: 'dashboard', path: '/dashboard' },
  { name: 'Drivers', key: 'drivers', path: '/drivers' },
  { name: 'Driver Schedule', key: 'driverSchedule', module: 'driverSchedule', path: '/driver-schedule' },
  { name: 'My Schedule', key: 'mySchedule', module: 'mySchedule', path: '/my-schedule' },
  { name: 'Staff Schedule', key: 'staffSchedule', module: 'staffSchedule', path: '/staff-schedule' },
  { name: 'Fleet', key: 'garage', path: '/warehouse' },
  { name: 'Inspection', key: 'inspection', path: '/vehicle-inspection' },
  { name: 'Tasks', key: 'tasks', path: '/tasks' },
  { name: 'Chat Support', key: 'chatSupport', path: '/chat-support' },
  {
    name: 'Push Notifications',
    key: 'pushNotifications',
    module: 'createUser',
    path: '/push-notifications',
  },
  { name: 'Driver Details', key: 'driverDetails', path: '/driver-detail', parentKey: 'drivers' },
  { name: 'User Management', key: 'createUser', path: '/user-management' },
];

const buildModuleState = (enabled) =>
  MODULES.reduce((accumulator, moduleKey) => {
    accumulator[moduleKey] = enabled;
    return accumulator;
  }, {});

export const ALL_MODULES = buildModuleState(true);
export const EMPTY_MODULES = buildModuleState(false);

export const normalizeRole = (role) => {
  if (role === ROLES.ADMIN || role === ROLES.MANAGER || role === ROLES.DISPATCH) {
    return role;
  }

  return null;
};

export const normalizeModules = (role, modules = {}) => {
  if (role === ROLES.ADMIN) {
    return { ...ALL_MODULES };
  }

  return MODULES.reduce((accumulator, moduleKey) => {
    accumulator[moduleKey] = modules?.[moduleKey] === true;
    return accumulator;
  }, {});
};

export const hasAccess = (user, module) => {
  if (!user || !module) {
    return false;
  }

  if (module === 'mySchedule') {
    return user.role === ROLES.MANAGER || user.role === ROLES.DISPATCH;
  }

  if (user.role === ROLES.ADMIN) {
    return true;
  }

  return user.modules?.[module] === true;
};

export const getDefaultRoute = (user) => {
  if (
    user &&
    (user.role === ROLES.MANAGER || user.role === ROLES.DISPATCH) &&
    hasAccess(user, 'mySchedule')
  ) {
    return '/my-schedule';
  }

  const firstAllowedItem = sidebarItems.find((item) =>
    hasAccess(user, item.module || item.key)
  );
  return firstAllowedItem?.path || null;
};
